'use client';

import React, { type ReactNode, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useStickyNav } from './StickyNavContext';

const Wrapper = styled.div<{ $stickyActive: boolean; $isHidden: boolean; $animate: boolean }>`
  @media (max-width: 767px) {
    position: sticky;
    top: ${({ $stickyActive }) => ($stickyActive ? '0' : '-9999px')};
    z-index: 11;
    transform: translateY(${({ $isHidden }) => ($isHidden ? '-100%' : '0')});
    transition: ${({ $animate }) => ($animate ? 'transform 0.35s ease-out' : 'none')};

    body:has(.map-layout) & {
      z-index: 2;
    }
  }
`;

const StickyNavHeader = ({ children }: { children: ReactNode }) => {
  const { isOut, scrollDirection } = useStickyNav();
  const wasRevealed = useRef(false);

  useEffect(() => {
    if (isOut && scrollDirection === 'up') wasRevealed.current = true;
    if (!isOut) wasRevealed.current = false;
  }, [isOut, scrollDirection]);

  const slidingIn = isOut && scrollDirection === 'up';
  const slidingOut = wasRevealed.current && isOut && scrollDirection === 'down';

  return (
    <Wrapper
      $stickyActive={isOut || scrollDirection === 'up'}
      $isHidden={isOut && scrollDirection === 'down'}
      $animate={slidingIn || slidingOut}
    >
      {children}
    </Wrapper>
  );
};

export default StickyNavHeader;
